import { render, staticRenderFns } from "./Teams2.vue?vue&type=template&id=b36ce2f4&scoped=true&"
import script from "./Teams2.vue?vue&type=script&lang=js&"
export * from "./Teams2.vue?vue&type=script&lang=js&"
import style0 from "./Teams2.vue?vue&type=style&index=0&id=b36ce2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36ce2f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VIcon,VLayout})
